<template>
    <section class="col-12 px-0 h-100">
        <div class="container mw-100 border-gray h-100 recommended-mobile-tile mb-0">
            <div class="col-12 px-0 bg-header-tile">
                <div class="row">
                    <!--/* PICTO 5G */-->
                    <img
                        v-if="offer.showPicto5G"
                        class="logo-5g"
                        :src="offer.picto5gSrc"
                        alt=""
                    >

                    <!--/* BANNIERE + TIMER */-->
                    <section class="pb-2">
                        <!--/* BANNIERE + TIMER */-->
                        <div v-if="offer.banner" class="col-12">
                            <div class="row align-items-center reco-banner">
                                <!--/* BANNER */-->
                                <div class="col-auto p-0 padding-bottom-banner">
                                    <div class="ob1-tag ob1-tag-primary">
                                        <span>{{ offer.banner }}</span>
                                    </div>
                                </div>
                                <!--/* TIMER */-->
                                <div v-if="offer.timerEndDateInMilliseconds" class="col-auto p-0 padding-left-tag padding-bottom-banner">
                                    <timer
                                        :end-date-in-milliseconds="offer.timerEndDateInMilliseconds"
                                        :color="offer.countDownColor ? offer.countDownColor : 'text-dark'"
                                    />
                                </div>
                            </div>
                        </div>
                        <div v-else class="col-12 reco-banner" />
                    </section>

                    <div class="col-12 pb-1 text-center">
                        <div class="reco-title text-primary pb-0 mb-0">
                            <h2 class="h4">
                                {{ offer.name }}
                            </h2>
                        </div>
                    </div>

                    <div class="col-12 pb-2 d-flex justify-content-center">
                        <a
                            :href="offer.foLink"
                            class="ob1-link-arrow"
                            :data-oevent-category="offer.foHighlightedTms.category"
                            :data-oevent-action="offer.foHighlightedTms.action"
                            :data-oevent-label="offer.foHighlightedTms.label"
                        >{{ offer.foLinkLabel }}</a>
                    </div>

                    <div class="col-12 py-0 text-center">
                        <hr class="separator separator--gray4 my-0">
                    </div>

                    <!--/* PRICE */-->
                    <div class="col-12 pt-1 text-center">
                        <ob1-prix
                            :custom="'reco-ob1-price h3 text-dark'"
                            :duration="offer.price.duration"
                            :initial-price="offer.price.initialPrice"
                            :is-mini="offer.price.mini"
                            :price="offer.price.price"
                            :price-details="offer.price.priceDetails"
                            :show-by-month="offer.price.showByMonth"
                            :show-end-of-promotion-price="offer.price.showEndOfPromotionPrice"
                            :show-from="offer.price.showFrom"
                            :show-promo-duration="offer.price.showPromoDuration"
                        />
                    </div>
                    <div class="col-12 pb-2 text-center">
                        <strong>{{ offer.commitment }}</strong>
                    </div>

                    <!--/* CLAIMS */-->
                    <div class="col-12 text-center px-0" :class="offerClaimsClass">
                        <div v-if="offer.claims.length > 0" class="reco-claim">
                            <div v-for="claim in offer.claims">
                                <div class="py-1 px-1" :class="claim.image ? offer.claimBgColor : 'bg-white'">
                                    <div v-if="claim.image">
                                        <img
                                            class="reco-mobile-claim-img"
                                            loading="lazy"
                                            :src="claim.image.url"
                                            :alt="claim.image.alt"
                                        >
                                    </div>
                                    <div v-for="attribute in claim.attributes">
                                        <p class="mb-0 px-2 d-flex align-items-center justify-content-center">
                                            <span v-html="attribute.textHtml" />
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: "RecommendedMobileOfferTile",
    props: {
        offer: {type: Object, required: true},
    },
    computed: {
        offerClaimsClass() {
            let returnedBgClass = 'bg-white';
            if ( this.offer && this.offer.claims && this.offer.claims.length > 0 ) {
                const lastOfferClaim = this.offer.claims[this.offer.claims.length -1];
                if (lastOfferClaim.image && this.offer.claimBgColor) {
                    returnedBgClass = this.offer.claimBgColor
                }
            }
            return returnedBgClass;
        }
    },
    methods: {
        handleBreakingSpaces(str) {
            return str.replace('&nbsp;', '\xa0');
        }
    }
}
</script>

<style scoped lang="scss">

@import 'ob1_variables', 'ob1_common';

.border-gray {
    border: px-to-rem(2) solid $gray-lighter;
}

.logo-5g {
    position: absolute;
    top: 1px;
    right: -13px;
    width: 23%;
}

.padding-bottom-banner {
    padding-bottom: 5px !important;
}

.padding-left-tag {
    padding-left: 10px !important;
}

.reco-mobile-claim-img {
    height: 40px;
    max-width: 80%;
}

</style>
